import loadSDK from './loadSDK';
class Logger {
  constructor(prefix) {
    this.prefix = '[' + (prefix || 'bext') + '] ';
    this.mode = false;
  }

  setMode(mode) {
    this.mode = mode;
    if (this.mode) {
      loadSDK('https://s0.meituan.net/static-prod01/com.sankuai.fspfecap.fe.capgastatic-files/vconsole.v3.14.6.min.js')
        .then(ret => {
          // 初始化vconsole
          // eslint-disable-next-line
          new window.VConsole();
        })
        .catch(err => console.error(err));
    }
  }

  base(method, ...args) {
    const { mode, prefix } = this;
    mode && console[method] && console[method](prefix, ...args);
  }

  log(...args) {
    this.base('log', ...args);
  }

  info(...args) {
    this.base('info', ...args);
  }

  debug(...args) {
    this.base('debug', ...args);
  }

  error(...args) {
    this.base('error', ...args);
  }
}

export default Logger;
